export const listSubscriptionItems = `
   query listSubscriptionItems($filter: SubscriptionItemsFilterInput, $limit: Int, $nextToken: String) {
       listSubscriptionItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              price
              quantity
              subscription
              created
           }
           nextToken
       }
   }
`;

export const getSubscriptionItem = `
   query getSubscriptionItem($id:ID!) {
       getSubscriptionItem(id:$id) {
          id
          price
          quantity
          subscription
          created
       }
}`;
